import * as React from 'react'
import isMobile from 'is-mobile'
import styles from './table.module.scss'
import { SummaryRow } from '../../views/cart';

interface ITableColumn {
  node?: React.ReactNode;
  style?: React.CSSProperties
}

type ITableRow = ITableColumn[];

export const Table: React.FC<{ header: ITableRow; rows: ITableRow[] }> = ({
  header,
  rows,
}) => {
  const columnWidth = `${100 / rows.length}%`;

  return (
    <div className={styles.table}>
      {isMobile() ? (
        <>
          {rows.map((row: ITableRow) => (
            Object.values(header).map((label, i: number) => (
              <SummaryRow field={label.node} value={Object.values(row)[i].node} />
            ))
          ))}
        </>
      ) : (
        <>
          <div className={styles.tableHeader}>
            <TableRow columnWidth={columnWidth} row={header} />
          </div>

          <div className={styles.tableBody}>
            {rows.map((row: ITableRow) => (
              <TableRow columnWidth={columnWidth} row={row} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export const TableRow: React.FC<{ row: ITableRow; columnWidth: string }> = ({
  row,
  columnWidth,
}) => (
  <div className={styles.tableRow}>
    {row.map((column: ITableColumn) => (
      <div className={styles.tableColumn} style={{ width: columnWidth, ...column.style }}>
        {column.node}
      </div>
    ))}
  </div>
);